import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "@mui/material";
import { SET_SUCCESS_PROMPT_SCHEDULE_PAGE } from "../../store/actionTypes/scheduleActionType";

const ScheduleSuccessPrompt = () => {
  const dispatch = useDispatch();
  const {
    isSuccessPromptSchedulePage: isSuccess,
    successMessageSchedulePage: successMessage,
  } = useSelector((state) => state.schedule);

  const { t: tCommon } = useTranslation();

  const handleClose = (event, reason) => {
    dispatch({ type: SET_SUCCESS_PROMPT_SCHEDULE_PAGE, payload: false });
  };

  return (
    isSuccess && (
      <Alert
        sx={{ my: 2 }}
        severity="success"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{tCommon("successPromptTitle")}</AlertTitle>
        {successMessage}
      </Alert>
    )
  );
};

export default ScheduleSuccessPrompt;
